import React from 'react';
import { AlertTriangle, RefreshCw, Wifi } from 'lucide-react';

interface ErrorStateProps {
  message: string;
  onRetry: () => void;
}

export default function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className="rounded-md border border-red-800/40 bg-red-950/20 p-8 flex flex-col items-center text-center max-w-lg mx-auto mt-8">
      <div className="w-12 h-12 rounded-full bg-red-950/40 border border-red-800/40 flex items-center justify-center mb-4">
        <AlertTriangle size={22} className="text-price-very-high" strokeWidth={2} />
      </div>

      <h2 className="text-base font-semibold text-foreground mb-2">
        Preisdaten nicht verfügbar
      </h2>

      <p className="text-sm text-muted-foreground mb-1 leading-relaxed">
        {message}
      </p>

      <p className="text-xs text-muted-foreground mb-6 flex items-center gap-1.5">
        <Wifi size={12} strokeWidth={2} />
        Bitte Internetverbindung prüfen und erneut versuchen.
      </p>

      <button
        onClick={onRetry}
        className="flex items-center gap-2 px-4 py-2 rounded-md bg-primary text-primary-foreground text-sm font-medium
          hover:bg-blue-600 active:scale-95 transition-all duration-150"
      >
        <RefreshCw size={14} strokeWidth={2.2} />
        Erneut versuchen
      </button>
    </div>
  );
}